import { render, staticRenderFns } from "./WeekMarketDetail.vue?vue&type=template&id=51661801&"
import script from "./WeekMarketDetail.vue?vue&type=script&lang=js&"
export * from "./WeekMarketDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports